import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-manual-ordered-service-parts',
  templateUrl: './manual-ordered-service-parts.component.html',
  styleUrls: ['./manual-ordered-service-parts.component.scss'],
  providers: [DialogService],
})
export class ManualOrderedServicePartsComponent implements OnInit {
  items: any[] = [];
  orderSource: string = '';

  constructor(private dynamicDialogRef: DynamicDialogRef, private dynamicDialogConfig: DynamicDialogConfig) {}

  ngOnInit() {
    const data = this.dynamicDialogConfig.data;

    this.items = data.items;
    this.orderSource = data.orderSource;
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }

  handleSubmit() {
    this.handleClose();
  }
}
